import { either } from 'fp-ts';

export const nodeIsText = (node: Node | Text): node is Text => {
  return (
    node.nodeType === Node.TEXT_NODE && 'length' in node && node.length > 0
  );
};
export const getRectsForNode = (node: Node) => {
  if (node.ownerDocument) {
    const range = node.ownerDocument.createRange();
    range.selectNode(node);
    return either.right(range.getClientRects());
  } else {
    return either.left({
      error: {
        message: 'Node does not have an owner document',
      },
    });
  }
};

export const nodeHasRects = (node: Node) => {
  const rects = getRectsForNode(node);
  if (either.isLeft(rects)) return false;
  else {
    return either.right.length > 0;
  }
};

export const nodeHasChildren = (node: Node) => {
  return node.childNodes.length > 0;
};

export const getTextNodeAfter = (node: Node) => {
  while (true) {
    if (nodeHasChildren(node)) {
      node = node.childNodes[0];
    } else if (node.nextSibling) {
      node = node.nextSibling;
    } else {
      const uncle = getSiblingAfterParentOf(node);
      if (uncle) {
        node = uncle;
      } else return null;
    }
    if (nodeIsText(node)) {
      break;
    }
  }
  return node;
};

export const getSiblingAfterParentOf = (node: Node) => {
  if (!node.ownerDocument) {
    throw new Error('Node owner document could not be found');
  }
  const body = node.ownerDocument.body;
  while (!node.nextSibling) {
    if (node === body) {
      return null;
    }
    node = node.parentNode as Node;
  }
  return node.nextSibling;
};

export const getTextNodeBefore = (node: Node) => {
  while (true) {
    if (nodeHasChildren(node)) {
      node = node.childNodes[node.childNodes.length - 1];
    } else if (node.previousSibling) {
      node = node.previousSibling;
    } else {
      const uncle = getSiblingBeforeParentOf(node);
      if (uncle) {
        node = uncle;
      } else return null;
    }
    if (nodeIsText(node)) {
      break;
    }
  }
  return node;
};

export const getSiblingBeforeParentOf = (node: Node) => {
  if (!node.ownerDocument) {
    throw new Error('Node does not container owner document');
  }
  const body = node.ownerDocument.body;
  while (!node.previousSibling) {
    if (node === body) {
      return null;
    }
    node = node.parentNode as Node;
  }
  return node.previousSibling;
};
